import { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from "react-redux";
//import StapelSignButtons from './helper/StapelSignButtons';
import StapelShowDocsinTooltip from './helper/StapelShowDocsinTooltip';
import ShowStapelDocSiganturen from './helper/ShowStapelDocSiganturen';

import { createStyles, rem, Group, Grid, ScrollArea, Indicator, Avatar, Badge, HoverCard, ActionIcon, Collapse} from '@mantine/core';
import { set_Acc_InProgress, set_signisstapel } from '../slice/mainslice';
import { PencilPlus, ChevronDown, ChevronUp } from 'tabler-icons-react';

const useStyles = createStyles((theme) => ({
  overdiv: {
    position: 'relative',
    display: 'inline-block',

  },
  relaname: {
    position: 'relative',
    display: 'inline-block',
    width: '300px',
    fontWeight: 'bold',
    fontSize: rem('12px'),
  },
  posidaustria: {
    position: 'absolute',
    display: 'inline-block',
    top: "-2px",
    left:"-10px",
  },
  posiok: {
    position: 'absolute',
    display: 'inline-block',
    top: "40px",
    left:"-3px",
    backgroundColor: "white",
  },
  screenok: {
    position: 'absolute',
    display: 'inline-block',
    top: "15px",
    left:"-12px",
    backgroundColor: "white",
  },
  scrollpad: {
    margin: '5px',
  },
  textsize: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('10px'),
    },
  },
}));

type DocumentSignMode = {
  resourceId: string;
  signMode: string;
};


/**
 * Generates the document reading interface .
 *
 * @param {any} props.divheight - reguliert das einblenden oder ausblenden der Scrollbar im Szene Container
 * @return {JSX.Element} the JSX element representing the document reading interface
 */
const StapelSignatur = (props:any) =>{
const { classes } = useStyles();  
const dispatch = useDispatch()
 // const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  const initdocs = useSelector((state: any) => state.user.meetingdocs)
  const initparticipants = useSelector((state: any) => state.user.meetinguser)
  const stapeluser = useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];
  const sceneid  = useSelector((state: any) => state.user.meetinginfo.currentScenarioId)
  
  //const [readinorigress, setreadinorigress] = useState({view: false, resourceId: "" });
  const [showscrollbar, setshowscrollbar] = useState(false);
  const [openPanels, setOpenPanels] = useState<Set<string>>(new Set());

  const togglePanel = (id: string) => {
    setOpenPanels(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const [contstrefheight, setcontstrefheight] = useState(0);

  const contstref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === contstref.current) {
          const { height } = entry.contentRect;
          setcontstrefheight(height);
         // console.log('Height changed:', height, 'px');
        }
      }
    });


    if (contstref.current) {
      observer.observe(contstref.current);
    }
    return () => {
      if (contstref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(contstref.current);
      }};

    }, []);


useEffect(() => {
  if (contstrefheight > 420 ) {
    setshowscrollbar(true)
  }
}, [contstrefheight]);


const participants = initparticipants.filter((obj: { role: any; }) => {
   // return obj.role !== "notar" && obj.role !== "gast"
   return obj.role !== "gast"
    });

const getParticipantById = (participantId: string) => {
  return participants.find(
    (p: any) => p.id === participantId
  );
};

const filterDocsByResourceIds = (
  initdocs: any[],
  params: { resourceId: string }[]
) => {
  const resourceIdSet = new Set(params.map(p => p.resourceId));

  return initdocs.filter(doc =>
    resourceIdSet.has(doc.resourceId)
  );
};
  
 


    // Add Mod for Direct start Sign
    


    const sendopendocforsignstapel_shared = (view:boolean, stapelSignLink:string, Id:string) => { 
  
    // Setze den aktuell user im Store für die Stapel Signatur  
     const openstapelpayload = {
          stapelId: Id,
          tempurl: stapelSignLink,     
        }
    

    dispatch(set_signisstapel(openstapelpayload))
    
        // Get Stapel Dokumente für diesen User
    //const filteredIds = filterStapelResourceIds(stapeluser, filteredParticipants[0].id);
    // Dokumente Namen für diesen Stapel 
    //const filteredDocs = filterEntriesByResourceIds(initdocs, filteredIds);

    const sendopendocforsign_sharedpayload = {
          StapelId : Id ,
          Showuser: view,
          SceneId: sceneid,
          Command: "opendoc",     
        }

        //console.log("sendopendocforsign_sharedpayload:",sendopendocforsign_sharedpayload);
    
        dispatch({ type: 'SIGNALR_SENDOPENDOCFORSIGNSTAPELSHARED', payload: sendopendocforsign_sharedpayload });
       
        dispatch(set_Acc_InProgress("Unterschriften"))

      }       
      
   
 
const rows = (stapeluser || []).map((item:any, index:any) => {

  //console.log('stapeluser item',item)
  
  const participantdetail = getParticipantById(item.participantId);
 
    // Dokumente Namen für diesen Stapel 
    const filteredDocs = filterDocsByResourceIds(initdocs, item.documentsSignModes);
    const countfilteredDocs = filteredDocs.length;
    const names = filteredDocs.map((item: { name: any; }) => {
      const name = item.name;
      return name.length > 150 ? name.substring(0, 150) + "..." : name;
  });

  const htmlnameList = names.map((name: any) => `<li>${name}</li>`).join("");
  const tooltipHtmlnameList = `<ul>${htmlnameList}</ul>`; 
  //console.log('item',item)

    
  //  console.log("countfilteredDocs", countfilteredDocs) 
    let a = participantdetail.lastName.substring(0,1)
    let b = participantdetail.firstName.substring(0,1)
    let initialen = a + b
    let fullname = participantdetail.lastName + " " + participantdetail.firstName

    let inmeetingcolor = "red"
    if (participantdetail.meetingParticipantStatus === null) {
      inmeetingcolor = "red"
    }
    if (participantdetail.meetingParticipantStatus === "LeftMeeting") {
      inmeetingcolor = "red"
    }
    if (participantdetail.meetingParticipantStatus === "InMeeting") {
      inmeetingcolor = "green"
    }

    // Avater Color Notar
    let isnotar = false
    if (participantdetail.role === "notar") {
      isnotar = true
    }


    //console.log("participantdetail:",participantdetail )


   return (
    <div key={index}>
    <Grid >
    <Grid.Col xs={12}  md={3} lg={3} xl={3}>
    <div className={classes.overdiv} >
        <Indicator inline size={12} offset={7} position="bottom-end" color={inmeetingcolor} withBorder>
        {!isnotar &&
          <Avatar  alt={fullname}  radius="lg"   >{initialen} </Avatar>
        } 
        {isnotar &&
          <Avatar color="blue" alt={fullname}  radius="xl"   >{initialen} </Avatar>
        } 
           
        </Indicator>
    </div> 
     </Grid.Col>
     <Grid.Col xs={12}  md={3} lg={4} xl={3}>
      <Group>
        <HoverCard width={400} shadow="md">
        <HoverCard.Target>
            <Badge size="xs" color="gray" variant="outline">{countfilteredDocs}</Badge>
            </HoverCard.Target>
            <HoverCard.Dropdown>
              <StapelShowDocsinTooltip tooltipHtmlnameList={tooltipHtmlnameList}/>
            </HoverCard.Dropdown>
            </HoverCard>
       
        </Group>

      
        <div className={classes.relaname}>{fullname}</div> 
         </Grid.Col>
         <Grid.Col span="auto">
             <Group  spacing={5} mt={2} position="right">
              {/*
               <StapelSignButtons participantId={item.id} isStapelSigned={item.isStapelSigned} sceneId={props.sceneId} scenarioId={props.scenarioId} />
              */}
              <ActionIcon
                size="xl"
                variant="transparent"
                onClick={() => sendopendocforsignstapel_shared(true, item.stapelSignLink, item.id)}
                >
                <PencilPlus size={26} strokeWidth={1} />
            </ActionIcon>
            <ActionIcon
                size="xl"
                variant="transparent"
                onClick={() => togglePanel(item.id)}
              >
                {openPanels.has(item.id) ? <ChevronUp size={26} strokeWidth={1} /> : <ChevronDown size={26} strokeWidth={1} />}
              </ActionIcon>
               </Group>
         </Grid.Col>

    </Grid>
    <Collapse in={openPanels.has(item.id)}>
      <ShowStapelDocSiganturen documentsSignModes={item.documentsSignModes} />
    </Collapse>
    <hr />
  </div>
   );
 });


  return (
    <>

    {!showscrollbar &&
      <>
      <div ref={contstref}>
        {rows}
      </div>
      </>
      }
      {showscrollbar &&
      <>
      <ScrollArea h={420} type="hover" offsetScrollbars>
        {rows}
      </ScrollArea>
      </>
      }
    </>
  );
}

export default StapelSignatur ;